import Back from './back.png'
import BackBlack from './back_black.png'
import Menu from './menu.png'
import Minimize from './minimize.png'
import Next from './next.png'
import NextBlack from './next_black.png'
import Send from './send.png'
import SendDisabled from './send_disabled.png'

export {
  Back,
  BackBlack,
  Menu,
  Minimize,
  Next,
  NextBlack,
  Send,
  SendDisabled,
}



// WEBPACK FOOTER //
// ./src/assets/icons/index.js